<template>
  <div class="py-4 container-fluid">
    <GridRow>
      <GridCol :md="12">
        <MetaSection></MetaSection>
      </GridCol>
      <GridCol :md="12">
        <form>
          <div class="d-flex flex-row justify-content-start gap-2 mb-4">
            <FormGroup class="m-0 filter">
              <!-- <select @change="changeKpi()" v-model="params.unitkerja_id" class="form-control">
                <option v-for="(item, index) in unitkerja" :key="index" :value="item.id">{{ item.name }}</option>
              </select> -->
              <model-list-select
                class="form-control"
                v-model="params.unitkerja_id"
                :list="unitkerja"
                option-value="id"
                option-text="name"
              />
                <!-- @change="changeKpi()" -->
                <!-- id="mySelectId"
                name="mySelectName"
                placeholder="Semua Unit Kerja" -->
            </FormGroup>
            
            <!-- <FormGroup class="m-0 filter">
              <select name="posisi" id="posisi" v-model="params.jabatan_id" class="form-control">
                <option value="">Semua Jabatan</option>
                <option v-for="(item, index) in jabatan" :key="index" :value="item.id">{{ item.name }}</option>
              </select>
            </FormGroup> -->
            
            <FormGroup class="m-0 filter">
              <model-list-select
                class="form-control"
                v-model="params.jabatan_id"
                :list="jabatan"
                option-value="id"
                option-text="name"
                placeholder="Semua Jabatan"
              />
            </FormGroup>
            
            <!-- <FormGroup class="m-0 filter">
              <model-list-select
                class="form-control"
                v-model="params.kpi_id"
                :list="list_kpi"
                option-value="id"
                option-text="title_jabatan"
                placeholder="Semua KPI"
              />
            </FormGroup> -->

            <FormGroup class="m-0 filter">
              <model-list-select
                class="form-control"
                v-model="params.periode_id"
                :list="list_periode"
                option-value="id"
                option-text="name"
                placeholder="Pilih Periode"
              />
            </FormGroup>
          </div>
        </form>
      </GridCol>

      <GridCol :md="12">
        <GridRow v-if="kpi.length > 0">
          <GridCol :md="6"
            v-for="(item, index) in kpi"
            :key="index"
            class="mb-4"
          >
            <RealisasiGabunganCard
              :kpi="item"
              :index_kpi="index"
              :detail_list_sub="true"
              detail_type="konsolidasi"
            />
          </GridCol>
        </GridRow>

        <p v-else class="text-center p-6">Data tidak ditemukan.</p>
      </GridCol>

    </GridRow>
  </div>
</template>

<style scoped>
li::marker {
  display: none;
}

li:first-child::before {
  content: "\2022";
  font-weight: bold;
  display: inline-block;
  width: 1em;
  margin-left: -1em;
  color: #0385F3 !important;
}
</style>

<script>
// import PerformanceHistoryChart from "../examples/Charts/PerformanceHistoryChart.vue";
// import Cards from "../components/CardComponent.vue";
import RealisasiGabunganCard from "@/components/RealisasiGabunganCard.vue";
import GridRow from "@/components/grid/GridRow.vue";
import GridCol from "@/components/grid/GridCol.vue";
import MetaSection from "@/components/MetaSection.vue";
import FormGroup from '@/components/FormGroup.vue';
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";

import UnitKerjaApi from '@/repository/api/UnitKerjaApi';
import JabatanApi from '@/repository/api/JabatanApi';
import KpiPeriodeApi from "@/repository/api/KpiPeriodeApi";
import LaporanGabunganApi from '@/repository/api/LaporanGabunganApi';
import KpiApi from "@/repository/api/KpiApi";

export default {
  name: "dashboard-default",
  components: {
    RealisasiGabunganCard,
    GridRow,
    GridCol,
    MetaSection,
    FormGroup,
    ModelListSelect,
  },
  data() {
    return {
      kpi: [],
      unitkerja: [],
      jabatan: [],
      list_periode: [],
      list_kpi: [],
      
      params: {
        unitkerja_id: "",
        jabatan_id: "",
        periode_id: '',
        // kpi_id: '',

        // testing only
        // kpi_id: '685198bb-bec8-4aea-a8d0-096ffebace04',
        // unitkerja_id: '99307423-5f3d-496f-a517-534eed982678',
        // periode_id: '55d63487-f204-4611-9b9c-6eeaaa6e5700',
      }
    };
  },
  watch: {
    // 'params': {
    //   handler: async function () {
    //     this.params.page = 1;
    //     this.params.jabatan_id = "";
    //     await this.getKpi();
    //   },
    //   deep: true,
    // },
    'params.unitkerja_id': {
      handler: async function () {
        await this.getJabatan();
        // await this.getKpi();
        this.changeKpi();
      },
      deep: true,
    },
    // 'params.kpi_id': {
    //   handler: async function () {
    //     await this.getData();
    //   }
    // }
    'params.jabatan_id': {
      handler: async function () {
        await this.getData();
      }
    },
    'params.periode_id': {
      handler: async function () {
        await this.getData();
      }
    },
  },
  methods: {
    async changeKpi() {
      // await this.getKpi();
      await this.getJabatan();
      await this.getData();
    },
    
    async getUnitKerja() {
      this.$store.state.loading = true;

      await UnitKerjaApi.getbyparam({
        page: 'all',
      })
      .then((response) => {
        this.unitkerja = response?.data;
        this.params.unitkerja_id = response?.data?.[0]?.id || '';
        // this.params.kpi_id = '';
        this.params.jabatan_id = '';
      }).catch(() => {
        this.unitkerja = [];
      });
      this.$store.state.loading = false;
    },
    
    async getJabatan() {
      this.$store.state.loading = true;
      let params = {
        page: 'all',
      };

      this.jabatan = [];
      this.params.jabatan_id = '';

      if (this.params.unitkerja_id != "") {
        // params = {
        //   unitkerja_id: this.params.unitkerja_id,
        // }
        params.unitkerja_id = this.params.unitkerja_id;
      }
      await JabatanApi.getbyparam(params)
        .then((response) => {
          // this.jabatan = response?.data || [];
          if (response?.data) {
            this.jabatan = [
              {
                id: '',
                name: 'Semua Jabatan',
              },
              ...response.data,
            ];
          }

          console.log(response?.data)
        }).catch(() => {
          this.jabatan = [];
        });

      this.$store.state.loading = false;
    },

    async getKpiPeriode() {
      await KpiPeriodeApi.getbyparam({
        status: 'active',
        limit: 100,
      })
        .then((response) => {
          this.list_periode = response?.data || [];
          this.params.periode_id = response?.data?.[0]?.id || '';
        })
        .catch((err) => {
          console.log(err)
        });
    },

    async getKpi() {
      this.list_kpi = [];
      this.params.kpi_id = '';

      await KpiApi.getByParamsNew({
        status: 'active',
        type: 'master',
        page: 'all',
        unitkerja_id: this.params.unitkerja_id,
        is_group: false,
      })
        .then((response) => {
          const list_kpi = response?.data || [];
          this.list_kpi = list_kpi.map((item) => {
            item.title_jabatan = `${item?.title} - ${item?.jabatan}`
            return item
          });
          this.params.kpi_id = response?.data?.[0]?.id || '';
        })
        .catch((err) => {
          console.log(err)
        });
    },

    async getData() {
      this.$store.state.loading = true;
      await LaporanGabunganApi.getListKonsolidasi(this.params)
        .then((response) => {
          this.kpi = response?.data;
        }).catch(() => {
          this.kpi = [];
        });
      this.$store.state.loading = false;
    }
  },
  async mounted() {
    this.$store.state.loading = true;
    await this.getUnitKerja();
    await this.getJabatan();
    // await this.getKpi();
    await this.getKpiPeriode();

    await this.getData();
    this.$store.state.loading = false;
  },
};
</script>
